import React from 'react';
import {AppText, AppErrorText} from './Typography';

// The file input reports selected files (not a raw ChangeEvent), so override
// the native onChange with the actual payload the handler receives.
interface AppFileInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  error?: string;
  multiple?: boolean;
  onChange?: (files: File[] | File | null) => void;
}

const AppFileInput: React.FC<AppFileInputProps> = ({label, error, className = '', multiple, onChange, ...inputProps}) => {
  const [fileNames, setFileNames] = React.useState<string[]>([]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('AppFileInput handleChange called with files:', e.target.files);
    if (multiple) {
      const files = Array.from(e.target.files || []);
      console.log('Multiple files selected:', files);
      setFileNames(files.map(f => f.name));
      // Pass the files array directly instead of the event
      if (onChange) {
        console.log('Calling onChange with files array:', files);
        onChange(files);
      }
    } else {
      const file = e.target.files?.[0];
      console.log('Single file selected:', file);
      setFileNames([file?.name || '']);
      // Pass the single file or null
      if (onChange) {
        console.log('Calling onChange with single file:', file);
        onChange(file || null);
      }
    }
  };

  return (
    <div className="w-full">
      {label && <AppText className="block mb-2 font-bold">{label}</AppText>}
      <input
        type="file"
        className={`w-full rounded-xl border bg-white px-4 py-3 text-lg font-normal text-grayText font-zain outline-none transition-all
          ${error ? 'border-red-500' : 'border-gray-200 focus:border-gray-500'}
          placeholder-gray-400
          ${className}`}
        multiple={multiple}
        onChange={handleChange}
        {...inputProps}
      />
      {fileNames.length > 0 && fileNames[0] && (
        <div className="mt-1 flex flex-col gap-1">
          {fileNames.map((name, i) => (
            <AppText key={i} className="text-xs text-gray-500">{name}</AppText>
          ))}
        </div>
      )}
      {error && <AppErrorText className="text-sm mt-2">{error}</AppErrorText>}
    </div>
  );
};

export default AppFileInput;
